import Vue from 'vue'

import axios from 'axios'
import { Message,Spin  } from 'view-design';
import router from "../router";
import CryptoJS from 'crypto-js';
import moment from 'moment';
// 配置axios默认设置
axios.defaults.withCredentials=true;   //允许跨域
axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8';
// axios.defaults.headers['token'] = utils.localData.get("token");
// 终止请求使用
const CancelToken = axios.CancelToken;
// 前端错误收集
const errors = [];
Vue.config.errorHandler = error => {
  // console.group('Vue.config.errorHandler')
  // console.log(error)
  // console.log(`${error.name}(${error.message})`)
  // console.groupEnd()
  // errors.push({router: window.location.pathname , content: error.stack})
  let _errorData = {
    "caseId": localStorage.CaseId,
    "content": error.stack,
    "errorType": `${error.name}(${error.message})`,
    "source": "web",
    "userAccount": localStorage.userName,
    "deviceNumber": localStorage.deviceConfig ? JSON.parse(localStorage.deviceConfig).deviceNumber : '',
    "collectTime": moment().format('YYYY-MM-DD HH:mm:ss'),
  };
  alimsService.post('/apm-es/logInfo/insert', _errorData).then( res => {
  })
}
window.onerror = (message, source, lineno, colno, error) => {
  // console.group('window.onerror')
  // console.log(error)
  // console.log(`${error.name}(${error.message})`)
  // console.groupEnd()
  //console.log(error.stack)
  // errors.push({router: window.location.pathname, content: error.stack})
  let _errorData = {
    "caseId": localStorage.CaseId,
    "content": error.stack,
    "errorType": `${error.name}(${error.message})`,
    "source": "web",
    "userAccount": localStorage.userName,
    "deviceNumber": localStorage.deviceConfig ? JSON.parse(localStorage.deviceConfig).deviceNumber : '',
    "collectTime": moment().format('YYYY-MM-DD HH:mm:ss'),
  };
  alimsService.post('/apm-es/logInfo/insert', _errorData).then( res => {
  })
}
window.addEventListener('error', event => {
  // console.group('window.addEventListener')
  // console.log(error)
  // console.log(`${error.name}(${error.message})`)
  // console.groupEnd()
  //console.log(event.error.stack)
  // errors.push({router: window.location.pathname, content: event.error.stack})
  let _errorData = {
    "caseId": localStorage.CaseId,
    "content": error.stack,
    "errorType": `${error.name}(${error.message})`,
    "source": "web",
    "userAccount": localStorage.userName,
    "deviceNumber": localStorage.deviceConfig ? JSON.parse(localStorage.deviceConfig).deviceNumber : '',
    "collectTime": moment().format('YYYY-MM-DD HH:mm:ss'),
  };
  alimsService.post('/apm-es/logInfo/insert', _errorData).then( res => {
  })
})
/*setInterval(()=>{
  if(errors.length > 0){
    const length = errors.length;
    // /apmAPI/qdlogs/addList
    // alimsService.post('/apm-es/logInfo/insert', errors).then( res => {
    //   errors.splice(0,length);
    // })
  }
},10000)*/

// 设置拦截器函数
const Interceptors = {
  request: [
    config => {
      //请求前要做什么
      if((config.method== 'get' &&config.params && config.params.noSpin) || (config.data && config.data.noSpin)){
        config.method== 'get' ? delete config.params.noSpin : '';
        config.method== 'post' ? delete config.data.noSpin : '';
      }else {
        //Spin.show();
      }

      if (localStorage.token) {
        config.headers.authorization = "Bearer " + localStorage.token;
      }

      // 终止请求使用
      config.cancelToken = new CancelToken(cancel => {
        window.__axiosPromiseCancelArr.push(cancel)
      });

      return config
    },
    error => {
      return Promise.reject(error)
    }
  ],
  response: [
    response => {
      // 先判断 http状态码
      //Spin.hide();
      if (response.status === 200 || response.status === 304) {
        // 再根据后台约定: flag:1-正常，0-后台报错
        let data = response.data;
        if(typeof data === "string" && data.indexOf("<!DOCTYPE ")>0){

          Message.error({
            content:"登录状态信息过期,请重新登录",
            duration: 3
          });
          /*router.push({
            path: "/login"
          });*/
          document.getElementById("gpyBox").style.left = "-704px";
          router.push(
            {name: `login`, query: {"isLogin": false}}
          );
          return Promise.reject("登录失效");
        }else{
          if(data.errorCode == "026" || data.errorCode == "004"){
            Message.error({
              content:"登录状态信息过期,请重新登录",
              duration: 3
            });
            //if(window.location.href.indexOf('apm') == -1){
            document.getElementById("gpyBox").style.left = "-704px";
              router.push(
                {name: `login`, query: {"isLogin": false}}
              );
            //}
            /*
            return Promise.reject("token失效");*/
          }
          return Promise.resolve(response.data)
        }
      }else{
          return Promise.reject(response);
      }
    },
    error => {
      let _error = error.toString();
      if(_error.indexOf('504') != -1 || _error.indexOf('503') != -1 || _error.indexOf('502') != -1){
        localStorage.reWorkUrl = window.location.href;
        // router.push({name:`wite`});
      }
      Spin.hide();
      if(axios.isCancel(error)) {
        // 终止请求使用
        // 为了终结promise链（实际请求）不会走到.catch();这样就不会触发错误提示
        console.info('Cancel Request SUCCESS !');
        return new Promise(() => {});
      } else {
        // Message.error({
        //   content:"服务异常！",
        //   duration: 3
        // });
        return Promise.reject(error)
      }
    }
  ]
}
// 配置alims接口设置
const alimsInstance = axios.create({
  timeout:180000
})
// 拦截器-请求阶段
alimsInstance.interceptors.request.use(...Interceptors.request)
// 拦截器-返回阶段
alimsInstance.interceptors.response.use(...Interceptors.response)
/////////////////////////////////////////////////////////////////////////////////
const KP = {
  key: 'hisign2020415cor', // 秘钥 16*n:
  iv: 'hisign2020415cor'  // 偏移量
};

function getAesString(data, key, iv) { // 加密
  key = CryptoJS.enc.Utf8.parse(key);
  // alert(key）;
  iv = CryptoJS.enc.Utf8.parse(iv);
  let encrypted = CryptoJS.AES.encrypt(data, key,
    {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
  return encrypted.toString();    // 返回的是base64格式的密文
}

function getDAesString(encrypted, key, iv) { // 解密
  key = CryptoJS.enc.Utf8.parse(key);
  iv = CryptoJS.enc.Utf8.parse(iv);
  let decrypted = CryptoJS.AES.decrypt(encrypted, key,
    {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
  return decrypted.toString(CryptoJS.enc.Utf8);      //
}
//alert(getDAesString('IUci2c58yalzbPszZJsf6BB/9bo5AikgV8TmTBzqaiY=','hisign2020415cor','hisign2020415cor'))
/*const aes = {
  en: (data) => getAesString(data, KP.key, KP.iv),
  de: (data) => getDAesString(data, KP.key, KP.iv)
};*/
export const aes = {
  en: (data) => getAesString(data, KP.key, KP.iv),
  de: (data) => getDAesString(data, KP.key, KP.iv)
};
//////////////////////////////////////////////////////////////////////////////////
export const dateFomart = {
  wordReplace(date){
    let _data = [];
    let _time = "";
    if(date.indexOf("-") != -1){
      _data = date.split("-");
    }
    if(date.indexOf("/") != -1){
      _data = date.split("/");
    }
    if(_data[2].split(' ').length == 2){
      _time = _data[2].split(' ')[1].split(":")[0] + "时" + _data[2].split(' ')[1].split(":")[1] + "分";

      _data[2] = _data[2].split(' ')[0];
    }


    return _data[0] + "年" + _data[1] + "月" + _data[2] + "日" + _time;
  }
}
//////////////////////////////////////////////////////////////////////////////////
// 码表转码
export const codeFomart  = {
  getCodeDescOfCode(codeClass,code){
    let codeData = localStorage.codeMap && localStorage.codeMap != "" ? JSON.parse(localStorage.codeMap) : "";
    if(codeData != "" && code){
      let codeList = codeData[codeClass];
      let _ = codeList.filter(o => o.code == code)[0];
      return ((_ && _.codedesc) ? _.codedesc : "");
    }else{
      return "";
    }
  }
}



//////////////////////////////////////////////////////////////////////////////////
// 封装自定义接口 get post 方法
const alimsService = {
  get (url, params) {
    return alimsInstance.get(url, {params: params})
  },
  post (url, params) {
    // 参数加密处理
    /*for(let key  in params){
      params[key] = aes.en(JSON.stringify(params[key]));
    }*/
    return alimsInstance.post(url, params)
  }
}
export default alimsService



// WEBPACK FOOTER //
// ./src/api/http.service.js